import React from 'react'
import Loadable from "react-loadable";
import LoadingPage from "../../LoadingPage";

const OrganizationAssociationLazy = Loadable({
  loader: () => import('./OrganizationAssociation'),
  loading: LoadingPage
})

const OrganizationAssociation = (props) => (
  <OrganizationAssociationLazy {...props} />
)

export default OrganizationAssociation
